import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import myImage from './img/logo.png';
import { Link } from 'react-router-dom';
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger } from './ui/navigation-menu';
import { blogPost } from '../data/DataBlog';

const NavBar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng, (err, t) => {
      if (err) return console.log('something went wrong loading', err);
      localStorage.setItem('selectedLanguage', lng); 
    });
  };

  useEffect(() => {
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    if (selectedLanguage) {
      i18n.changeLanguage(selectedLanguage); 
    }
  }, []); 

  return (
    <>
    <nav className='sticky top-0 z-50 text-gray-800 bg-white shadow-lg'>
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex items-center flex-shrink-0"> 
              <Link to="/" className="flex items-center">
                <img src={myImage} alt="qastan logo" className="h-14" />
              </Link>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="flex items-baseline mt-3 ml-10 space-x-4">
              <NavigationMenu>
                <NavigationMenuList>
                  
                  <NavigationMenuItem>
                    <NavigationMenuTrigger className='font-medium'>Info</NavigationMenuTrigger>
                    <NavigationMenuContent className='p-4'>
                      <NavigationMenuLink href="/wat-is-peppol">
                        <div className='p-2 rounded-lg whitespace-nowrap hover:bg-slate-50'>
                          <p className='font-semibold'>Wat is Peppol?</p>
                          <p className='text-sm text-neutral-400'>Kom meer te weten over Peppol</p>
                        </div>
                      </NavigationMenuLink>
                      
                      <NavigationMenuLink href="/boekhouders">
                        <div className='p-2 rounded-lg whitespace-nowrap hover:bg-slate-50'>
                          <p className='font-semibold'>Boekhouders</p>
                          <p className='text-sm text-neutral-400'>Hoe Peppol werkt voor boekhoudkantoren en accountants</p>
                        </div>
                      </NavigationMenuLink>

                      <NavigationMenuLink href="/ondernemers">
                        <div className='p-2 rounded-lg whitespace-nowrap hover:bg-slate-50'>
                          <p className='font-semibold'>Ondernemingen</p>
                          <p className='text-sm text-neutral-400'>Lees meer over Peppol voor ondernemingen</p>
                        </div>
                      </NavigationMenuLink>
                    </NavigationMenuContent>
                  </NavigationMenuItem>

                  <NavigationMenuItem>
                    <NavigationMenuTrigger className='font-medium'>Blog</NavigationMenuTrigger>
                    <NavigationMenuContent className='flex flex-col gap-4 p-4'>
                      <NavigationMenuLink href="/blog" className='h-full'>
                        <div className='h-full p-2 rounded-lg bg-slate-50'>
                          <p className='font-semibold'>Blog</p>
                          <p className='text-sm text-neutral-400 max-w-sm min-w-[200px] lg:min-w-[400px]'>Ontdek de laatste trends, tips en nieuwtjes over elektronische facturatie, Peppol en digitale transformatie. Blijf op de hoogte via onze blog.</p>
                        </div>
                      </NavigationMenuLink>
          
                      
                      <div>
                        <p className='mb-2 text-sm font-medium border-b text-neutral-600'>Laatste blogposts</p>
                        {blogPost && blogPost.slice(0, 3).map((blog, index) => (
                            <NavigationMenuLink href={`/blog/${blog.id}~${blog[i18n.language as Language].title.replace(' ', '-')}`} key={`blog-${index}`}>
                            <div className='p-2 rounded-lg min-w-[200px] lg:min-w-[400px] hover:bg-slate-50'>
                              <p className='text-sm font-medium'>{blog[i18n.language as Language].title}</p>
                              <p className='text-xs text-neutral-400 line-clamp-2'>{blog[i18n.language as Language].subtitle}</p>
                            </div>
                          </NavigationMenuLink>
                        ))}
                      </div>
                    </NavigationMenuContent>
                  </NavigationMenuItem>

                </NavigationMenuList>
              </NavigationMenu>
              {/* <Link to="/wat-is-peppol" className={`text-gray-800 ${isActive('/wat-is-peppol') || location.pathname.includes('/wat-is-peppol/') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-sm font-semibold uppercase transition duration-300 ease-in-out`}>Wat is Peppol?</Link> */}

              {/* <Link to="/Boekhouders" className={`text-gray-800 ${isActive('/Boekhouders') ? 'text-legoOrange' : 'hover:text-legoOrange '} px-3 py-2 rounded-md text-sm font-semibold uppercase transition duration-300 ease-in-out`}>{t('Home.Navbar.Boekhouders')}</Link> */}
              {/* <Link to="/Ondernemers" className={`text-gray-800 ${isActive('/Ondernemers') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-sm font-semibold uppercase transition duration-300 ease-in-out`}>{t('Home.Navbar.Ondernemers')}</Link> */}
              <Link to="/Contact" className={`text-gray-800 ${isActive('/Contact') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-sm font-medium transition duration-300 ease-in-out`}>{t('Home.Navbar.Contact')}</Link>
              {/* <Link to="/Blog" className={`text-gray-800 ${isActive('/Blog') || location.pathname.includes('/Blog/') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-sm font-semibold uppercase transition duration-300 ease-in-out`}>{t('Home.Navbar.Blog')}</Link> */}
              
              <Link to="/start-met-peppol" className={`text-legoOrange ${isActive('/start-met-peppol') || location.pathname.includes('/start-met-peppol/') ? 'text-legoOrange underline' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-sm font-semibold transition duration-300 ease-in-out hover:underline`}>Start met Peppol</Link>     
            
              <a className='flex items-center justify-center h-10 px-2 text-sm font-medium text-white bg-legoOrange' href="https://peppol.qastan.be/portal/login">Naar portaal</a>
            </div>
          </div>
          <div className="flex -mr-2 md:hidden">
            <button
                onClick={toggleMenu}
                type="button"
                className="inline-flex items-center justify-center p-2"
              >
                <svg
                  className={`${isOpen ? 'hidden' : 'block'} h-8 w-8`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  stroke="#1F2937"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  style={{ transition: 'opacity 0.5s ease-in-out' }}
                >
                  <path d="M4 6h16M4 12h16m-7 6h7"></path>
                </svg>
                <svg
                  className={`${isOpen ? 'block' : 'hidden'} h-8 w-8`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  stroke="#1F2937"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  style={{ transition: 'opacity 0.5s ease-in-out' }}
                >
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
          </div>
        </div>
      </div>
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 sm:px-3">
          <Link to="/Boekhouders" className={`block text-gray-800 ${isActive('/Boekhouders') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-base font-semibold transition duration-300 ease-in-out`}>{t('Home.Navbar.Boekhouders')}</Link>
          <Link to="/Ondernemers" className={`block text-gray-800 ${isActive('/Ondernemers') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-base font-semibold transition duration-300 ease-in-out`}>{t('Home.Navbar.Ondernemers')}</Link>
          <Link to="/Contact" className={`block text-gray-800 ${isActive('/Contact') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-base font-semibold transition duration-300 ease-in-out`}>{t('Home.Navbar.Contact')}</Link>
          <Link to="/Blog" className={`block text-gray-800 ${isActive('/Blog') || location.pathname.includes('/Blog/') ? 'text-legoOrange' : 'hover:text-legoOrange'} px-3 py-2 rounded-md text-base font-semibold transition duration-300 ease-in-out`}>{t('Home.Navbar.Blog')}</Link>
      
          <div className='flex pl-3'>
                <p className={`duration-300 hover:text-legoOrange font-bold ${i18n.language === 'nl' ? 'text-legoOrange' : 'text-gray-800'}`} onClick={() => changeLanguage("nl")} style={{ cursor: 'pointer' }}>
                  NL
                </p>
                <p className='mx-2 font-bold text-gray-800'>|</p>
                <p className={`duration-300 hover:text-legoOrange font-bold ${i18n.language === 'fr' ? 'text-legoOrange' : 'text-gray-800'}`} onClick={() => changeLanguage("fr")} style={{ cursor: 'pointer' }}>
                  FR
                </p>
            </div>
        </div>
      </div>
    </nav>
    </>
  );
};

export default NavBar;
